import React from 'react';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { Button } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import Content from '../WizardStepTemplate/Content';

const useStyles = buildUseStyles('ScenarioActivationDeclineConfirmation', (theme) => ({
  specificPageLink: {
    fontSize: theme.typography.fontSize1Rem,
    fontWeight: theme.typography.fontWeightBold,
    '&:hover': {
      backgroundColor: 'initial',
    },
  },
}));

export default function ScenarioActivationDeclineConfirmation({ className, resource }) {
  const { submitPageResource, setPageContentCollection } = usePageContentContext();
  const classes = useStyles();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const resourceType = resource.type();

  async function submitShouldNotActivate() {
    logStandardizedEvent(categories.clientWhatIf, eventTypes.clickButton, `${resourceType} - Activation Deferred`);
    resource.attr('shouldActivate', 'false');
    const { response, error } = await submitPageResource();
    if (!error && response) {
      setPageContentCollection(response);
    }
  }

  return <>
    <WizardStepWrapperTemplate
      className={className}
      layout={Content}
      metaOverrideSet={BaseWizardStepOverride}
      LayoutProps={{ resource }}
      resource={resource}
      SpecificPageLinkComponent={() => (
        <Button
          className={classes.specificPageLink}
          color={'primary'}
          variant={'text'}
          onClick={submitShouldNotActivate}
          test={'specific-page-link-button'}
        >
          {'I’ll stay uninvested, even if it delays my progress'}
        </Button>
      )}
    />
  </>;
}
